(function () {
  var sections = document.querySelectorAll('.oddit-section-collection-header');
  if (!sections.length) return;

  function initSection(section) {
    var select = section.querySelector('.oddit-section-collection-header__sort-select');
    var current = section.querySelector('.oddit-section-collection-header__sort-current');
    if (!select || !current) return;

    function syncLabel() {
      var option = select.options[select.selectedIndex];
      if (option) current.textContent = option.text;
    }

    syncLabel();
    select.addEventListener('change', function () {
      syncLabel();
      if (select.form) select.form.submit();
    });
  }

  Array.prototype.forEach.call(sections, initSection);

  function countActiveFiltersFromUrl(search) {
    var params;
    try { params = new URLSearchParams(search || ''); }
    catch (_) { return 0; }
    var count = 0;
    var hasPriceRange = false;
    var keys = (typeof params.keys === 'function') ? params.keys() : null;
    if (!keys) return 0;
    var step = keys.next();
    while (!step.done) {
      var key = step.value;
      step = keys.next();
      if (key.indexOf('filter.') !== 0) continue;
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        if (!hasPriceRange) { count++; hasPriceRange = true; }
        continue;
      }
      count++;
    }
    return count;
  }

  function updateFilterCountBadges() {
    var count = countActiveFiltersFromUrl(window.location.search);
    var labels = document.querySelectorAll('[data-oddit-filter-count-label]');
    Array.prototype.forEach.call(labels, function (el) {
      el.textContent = count > 0 ? 'Filters (' + count + ')' : 'Filters';
    });
  }

  updateFilterCountBadges();
  window.addEventListener('popstate', updateFilterCountBadges);
  document.addEventListener('oddit:collection-filters-changed', updateFilterCountBadges);

  function findDrawer() {
    return document.querySelector('[data-filter-drawer]');
  }

  function findOverlay() {
    return document.querySelector('.oddit-section-main-collection__sidebar-overlay');
  }

  function openDrawer() {
    var drawer = findDrawer();
    var overlay = findOverlay();
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) {
      overlay.hidden = false;
      overlay.classList.add('is-open');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = findDrawer();
    var overlay = findOverlay();
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
    }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-oddit-filter-drawer-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-filter-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = findDrawer();
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
  });
})();